import { http } from '@/plugins/http';
import { getData } from '@/utils/get';

class RobotType {
  get = () => http.post('robot-types', { 'manufacturer': 'fetch' }).then(getData);
}

export default new RobotType();
